import { StringUtils } from "../../../utils/string-utils";
import { BeanPrimaryEntity } from "../../bean-primary-entity";

export class Tanks extends BeanPrimaryEntity {
    tankId: number;
    tankName: string;
    tankType: string;
    unitId: number;
    startUpDate: Date | null;
    startUpResolution: number | null;
    shutDownDate: Date | null;
    shutDownResolution: number | null;
    tankStatus: string | null;
    designCapacity: number | null;
    hsProductsId: string;
    designDiameter: string;
    heightLength: string;
    diameterUom: string | null;
    designMawp: number | null;
    mawpUom: string | null;
    tankInfo: string;
    apiInspection: Date | null;
    apiResolution: number | null;
    qcCompany: string;

    protected constructor(entity?: any) {
        super(entity);
        this.tankId = entity?.tankId ?? null;
        this.tankName = entity?.tankName ?? '';
        this.tankType = entity?.tankType ?? '';
        this.unitId = entity?.unitId ?? null;
        this.startUpDate = entity?.startUpDate ?? null;
        this.startUpResolution = entity?.startUpResolution ?? null;
        this.shutDownDate = entity?.shutDownDate ?? null;
        this.shutDownResolution = entity?.shutDownResolution ?? null;
        this.tankStatus = entity?.tankStatus ?? null;
        this.designCapacity = entity?.designCapacity ?? null;
        this.hsProductsId = entity?.hsProductsId ?? '';
        this.designDiameter = StringUtils.toStringNeverNull(entity?.designDiameter);
        this.heightLength = StringUtils.toStringNeverNull(entity?.heightLength);
        this.diameterUom = entity?.diameterUom ?? null;
        this.designMawp = entity?.designMawp ?? null;
        this.mawpUom = entity?.mawpUom ?? null;
        this.tankInfo = entity?.tankInfo ?? '';
        this.apiInspection = entity?.apiInspection ?? null;
        this.apiResolution = entity?.apiResolution ?? null;
        this.qcCompany = entity?.qcCompany ?? '';
    }

}
